import subMonthAdjust from './subMonthAdjust'
export default {
  components: { subMonthAdjust },
  data() {
    return {
      subMonthAdjustVisible: false
    }
  },
  methods: {
    showsubMonthAdjust(row) {
      this.rowData = row;
      this.subMonthAdjustVisible = true;
    }
  }
}